<template>

  <t-wrapped :show="(row || cols === '12' && !hidden) && !notRow">

    <b-row>

      <ValidationProvider
          class="TextInput"
          tag="div"
          :class="{['col-md-' + cols] : !notRow && cols && !hidden,'input-hidden':hidden, 'has-color-palette':(colorReduced || colorSketch) && showColors, ['type-input-'+type]:true}"
          :vid="vid"
          :name="name || label"
          :rules="localRules"
          :persist="true"
          ref="provider"
          v-slot="validationContext"
      >

        <b-form-group style="position: relative">

          <div v-if="range">

            <label v-if="label !== '' && !hideLabel && type !== 'checked'" :for="label"
                   class="d-flex justify-content-between align-content-end">

              <div>{{ localLabel }}</div>

              <div v-if="innerValue > 0"><b>{{ innerValue | number }}%</b></div>
              <div v-else><b>0%</b></div>

              <t-help :title="help" v-if="help.length > 0"/>

            </label>


          </div>

          <div v-else>

            <label v-if="label !== '' && !hideLabel && type !== 'checked'" :for="label">

              <div>{{ localLabel }}</div>


            </label>

            <t-help :title="help" v-if="help.length > 0"/>

          </div>

          <t-wrapped :show="hasSlotGroupInputPrepend || hasSlotGroupInputAppend">

            <b-input-group :class="{'input-has-append':hasSlotGroupInputAppend}">

              <div class="input-icon-group"
                   :class="{'input-icon-focused':inputIsFocus, [classIconGroup] : classIconGroup !== ''}"
                   v-if="hasSlotInputIcon || hasIconByMask">
                <slot name="input-icon">
                  <b-icon-calendar v-if="date && !dateRemoveCalendar && type !== 'fixed'"></b-icon-calendar>
                </slot>
              </div>

              <template #prepend v-if="hasSlotGroupInputPrepend">
                <div class="input-group-text">
                  <slot name="input-group-prepend"></slot>
                </div>
              </template>

              <template v-if="type === 'fixed'">

                <div class="vs--disabled_label form-control"
                     :class="{'text-bold':bold, 'bg-fixed-focus':highlight,'text-right':number || money || percent,'bg-fixed-normal':!highlight, [classInput] : classInput !== ''}">
                  <span v-if="select || selectCommon || radio">{{ selectText }} </span>
                  <span v-else-if="lpad !== '' || lpad > 0">{{ innerValue | lpad(lpad) }}</span>
                  <span v-else-if="date">{{ innerValue | date }}</span>
                  <span v-else-if="datetime">{{ innerValue | datetime }}</span>
                  <span v-else-if="number || range">{{ innerValue | number }}</span>
                  <span v-else-if="money">{{ innerValue | money }}</span>
                  <span v-else-if="percent">{{ innerValue | percent(localDecimals) }}</span>
                  <span v-else>{{ innerValue }}</span>
                </div>

                <b-form-invalid-feedback v-if="addError!==''" style="display: inherit">
                  {{ addError }}
                </b-form-invalid-feedback>

              </template>


              <template v-if="type === 'hidden'">

                <input type="hidden" v-model="innerValue"/>

              </template>

              <template v-if="type === 'file'">

                <b-form-file
                    capture
                    :autofocus="focus"
                    @keyup.enter.prevent
                    @keydown.enter.prevent
                    :id="localInputId"
                    v-model="innerValue"
                    :state="getValidationState(validationContext)"
                    :placeholder="placeholder"
                    multiple
                    drop-placeholder="Arraste para aqui o arquivo"
                ></b-form-file>

              </template>

              <template v-if="type === 'range'">

                <b-form-input
                    :class="{[classInput] : classInput !== ''}"
                    class="form-range"
                    @focusin="onFocusInInput"
                    @focusout="onFocusOutInput"
                    ref="input"
                    v-model="innerValue"
                    type="range"
                    :id="localInputId"
                    :autofocus="focus"
                    :autocomplete="autocomplete"
                    :disabled="disabledCheck"
                    :placeholder="placeholder"
                    :state="getValidationState(validationContext)"
                ></b-form-input>


              </template>


              <template v-if="type === 'text'">

                <div style="position: relative" class="input-template">

                  <!--Caso a mascara não tenho sido aplicada já desenha na tela-->
                  <b-form-input v-if="!maskApply && !submitted"
                                v-model="innerValue"
                                @keyup.enter.prevent
                                @keydown.enter.prevent
                                @focusin="onFocusInInput"
                                @focusout="onFocusOutInput"
                                ref="input"
                                :class="{'upperCase':localUpper,'lowerCase':localLower, 'hasSlotInputIcon':hasSlotInputIcon,'padding-input-color':(colorReduced || colorSketch), [classInput] : classInput !== ''}"
                                :id="localInputId"
                                :autocomplete="autocomplete"
                                :type="password || passwordSecurity ? 'password' : 'text'"
                                :autofocus="focus"
                                :disabled="disabledCheck"
                                :placeholder="placeholder"
                                :state="getValidationState(validationContext)"
                  ></b-form-input>


                  <!-- funciona apenas se não houver mascara aplicada -->
                  <b-form-input v-else-if="submitted"
                                v-model="innerValue"
                                @focusin="onFocusInInput"
                                @focusout="onFocusOutInput"
                                ref="input"
                                :class="{'upperCase':localUpper,'lowerCase':localLower, 'hasSlotInputIcon':hasSlotInputIcon, [classInput] : classInput !== ''}"
                                class="input-submited"
                                :id="localInputId"
                                :autofocus="focus"
                                :autocomplete="autocomplete"
                                :disabled="disabledCheck"
                                :placeholder="placeholder"
                                :state="getValidationState(validationContext)"

                  ></b-form-input>


                  <date-picker v-else-if="date || datetime" title-format="DD/MM/YYYY" format="DD/MM/YYYY"
                               :append-to-body="false" ref="datePicker"
                               value-type="format" :clearable="false" v-model="innerDate">

                    <template #icon-calendar>&nbsp;</template>

                    <template #input>

                      <b-form-input
                          :class="{'input-with-icon':hasIconByMask,'hasSlotInputIcon':hasSlotInputIcon, [classInput] : classInput !== ''}"
                          @keyup.enter.prevent="setDateAndClose"
                          @keydown.enter.prevent="setDateAndClose"
                          @keyup.tab="closeDatePicker"
                          @keydown.tab="closeDatePicker"
                          @keydown.esc="closeDatePicker"
                          @keyup="dateRemoveByRegex"
                          @keydown="dateRemoveByRegex"
                          @focusin="onFocusInInput"
                          @focusout="onFocusOutInput"
                          v-model="innerDate"
                          :id="localInputId"
                          :autofocus="focus"
                          :autocomplete="autocomplete"
                          :disabled="disabledCheck"
                          :placeholder="placeholder"
                          :state="getValidationState(validationContext)"
                      >
                      </b-form-input>

                    </template>

                  </date-picker>


                  <!--                  <date-pick ref="datePicker" v-else-if="date || datetime"
                                               :nextMonthCaption="datePiker.nextMonthCaption"
                                               :setTimeCaption="datePiker.setTimeCaption"
                                               :weekdays="datePiker.weekdays" :months="datePiker.months"
                                               :prevMonthCaption="datePiker.prevMonthCaption"
                                               style="display: block;width: 100%"
                                               :placeholder="placeholder"
                                               v-model="innerDate">

                                      <template #default="{toggle}" v-if="!dateRemoveCalendar">

                                        <b-form-input
                                            :class="{'input-with-icon':hasIconByMask, [classInput] : classInput !== ''}"
                                            v-mask="'##/##/####'"
                                            @keyup.enter.prevent="setCurrentDate"
                                            @keydown.enter.prevent="setCurrentDate"
                                            @focus="toggle"
                                            @focusin="onFocusInInput"
                                            @focusout="onFocusOutInput"
                                            v-model="innerValue"
                                            :id="localInputId"
                                            :autofocus="focus"
                                            :autocomplete="autocomplete"
                                            :disabled="disabledCheck"
                                            :placeholder="placeholder"
                                            :state="getValidationState(validationContext)"
                                        >
                                        </b-form-input>

                                      </template>

                                      <template #default v-else>

                                        <b-form-input
                                            :class="{'input-with-icon':hasIconByMask}"
                                            v-mask="'##/##/####'"
                                            @keyup.enter.prevent="setCurrentDate"
                                            @keydown.enter.prevent="setCurrentDate"
                                            @focusin="onFocusInInput"
                                            @focusout="onFocusOutInput"
                                            @blur="checkDateValue()"
                                            ref="input"
                                            v-model="innerValue"
                                            :id="localInputId"
                                            :autofocus="focus"
                                            :autocomplete="autocomplete"
                                            :disabled="disabledCheck"
                                            :placeholder="placeholder"
                                            :state="getValidationState(validationContext)"
                                        >
                                        </b-form-input>


                                      </template>

                                    </date-pick>-->


                  <b-form-input v-else-if="cnpjOrCpf"
                                v-mask="['###.###.###-##', '##.###.###/####-##']"
                                @keyup.enter.prevent
                                @keydown.enter.prevent
                                @focusin="onFocusInInput"
                                @focusout="onFocusOutInput"
                                ref="input"
                                v-model="innerValue"
                                :id="localInputId"
                                :autofocus="focus"
                                :autocomplete="autocomplete"
                                :disabled="disabledCheck"
                                :placeholder="placeholder"
                                :state="getValidationState(validationContext)"
                  ></b-form-input>

                  <b-form-input v-else-if="cnpj"
                                v-mask="'##.###.###/####-##'"
                                :class="{'input-with-icon':hasIconByMask,'hasSlotInputIcon':hasSlotInputIcon, [classInput] : classInput !== ''}"
                                @keyup.enter.prevent
                                @keydown.enter.prevent
                                @focusin="onFocusInInput"
                                @focusout="onFocusOutInput"
                                ref="input"
                                v-model="innerValue"
                                :id="localInputId"
                                :autofocus="focus"
                                :autocomplete="autocomplete"
                                :disabled="disabledCheck"
                                :placeholder="placeholder"
                                :state="getValidationState(validationContext)"
                  ></b-form-input>

                  <b-form-input v-else-if="cpf"
                                v-mask="'###.###.###-##'"
                                :class="{'input-with-icon':hasIconByMask,'hasSlotInputIcon':hasSlotInputIcon, [classInput] : classInput !== ''}"
                                @keyup.enter.prevent
                                @keydown.enter.prevent
                                @focusin="onFocusInInput"
                                @focusout="onFocusOutInput"
                                ref="input"
                                v-model="innerValue"
                                :id="localInputId"
                                :autofocus="focus"
                                :autocomplete="autocomplete"
                                :disabled="disabledCheck"
                                :placeholder="placeholder"
                                :state="getValidationState(validationContext)"
                  ></b-form-input>

                  <b-form-input v-else-if="cep"
                                v-mask="'#####-###'"
                                :class="{'input-with-icon':hasIconByMask,'hasSlotInputIcon':hasSlotInputIcon, [classInput] : classInput !== ''}"
                                @keyup.enter.prevent
                                @keydown.enter.prevent
                                @focusin="onFocusInInput"
                                @focusout="onFocusOutInput"
                                ref="input"
                                v-model="innerValue"
                                :id="localInputId"
                                :autofocus="focus"
                                :autocomplete="autocomplete"
                                :disabled="disabledCheck"
                                :placeholder="placeholder"
                                :state="getValidationState(validationContext)"
                  ></b-form-input>

                  <b-form-input v-else-if="tel"
                                v-mask="['(##) ####-####', '(##) #####-####']"
                                :class="{'input-with-icon':hasIconByMask,'hasSlotInputIcon':hasSlotInputIcon, [classInput] : classInput !== ''}"
                                @keyup.enter.prevent
                                @keydown.enter.prevent
                                @focusin="onFocusInInput"
                                @focusout="onFocusOutInput"
                                ref="input"
                                v-model="innerValue"
                                :id="localInputId"
                                :autofocus="focus"
                                :autocomplete="autocomplete"
                                :disabled="disabledCheck"
                                :placeholder="placeholder"
                                :state="getValidationState(validationContext)"
                  ></b-form-input>

                  <b-form-input v-else-if="time"
                                v-mask="['##:##']"
                                @keyup.enter.prevent
                                @keydown.enter.prevent
                                @focusin="onFocusInInput"
                                @focusout="onFocusOutInput"
                                ref="input"
                                v-model="innerValue"
                                :id="localInputId"
                                :autofocus="focus"
                                :autocomplete="autocomplete"
                                :disabled="disabledCheck"
                                :placeholder="placeholder"
                                :state="getValidationState(validationContext)"
                  ></b-form-input>


                  <b-form-input
                      v-else-if="url"
                      v-model="innerValue"
                      :class="{'input-with-icon':hasIconByMask,'hasSlotInputIcon':hasSlotInputIcon, [classInput] : classInput !== ''}"
                      @keyup.enter.prevent
                      @keydown.enter.prevent
                      @focusin="onFocusInInput"
                      @focusout="onFocusOutInput"
                      ref="input"
                      :disabled="disabledCheck"
                      :autocomplete="autocomplete"
                      :placeholder="placeholder"
                      :state="getValidationState(validationContext)"/>


                  <div v-else-if="money" class="input-group">

                    <money
                        class="text-right form-control"
                        :class="{'is-invalid':checkInvalid(validationContext),'input-with-icon':hasIconByMask,'hasSlotInputIcon':hasSlotInputIcon, [classInput] : classInput !== ''}"
                        @focus.native="onFocusInInput"
                        @blur.native="onFocusOutInput"
                        ref="input"
                        v-model="innerNumeric"
                        :id="localInputId"
                        :autofocus="focus"
                        :autocomplete="autocomplete"
                        :disabled="disabledCheck"
                        v-bind="moneyConfig"
                    ></money>

                    <span class="v-money-currency">R$</span>


                  </div>

                  <div v-else-if="percent" class="input-group">

                    <money
                        class="text-right form-control"
                        :class="{'is-invalid':checkInvalid(validationContext),'input-with-icon':hasIconByMask,'hasSlotInputIcon':hasSlotInputIcon, [classInput] : classInput !== ''}"
                        @focus.native="onFocusInInput"
                        @blur.native="onFocusOutInput"
                        ref="input"
                        v-model="innerValue"
                        :id="localInputId"
                        :autofocus="focus"
                        :autocomplete="autocomplete"
                        :disabled="disabledCheck"
                        decimal=","
                        thousands="."
                        sufix="%"
                        :precision="localDecimals"
                        :masked="false"
                    />

                    <span class="v-money-percent">%</span>

                  </div>


                  <b-form-input
                      v-else-if="number"
                      :class="{'text-right':localDecimals > 0, 'input-with-icon':hasIconByMask,'hasSlotInputIcon':hasSlotInputIcon, [classInput] : classInput !== ''}"
                      @keyup.enter.prevent
                      @keydown.enter.prevent
                      @focusin="onFocusInInput"
                      @focusout="onFocusOutInput"
                      @blur="checkNumericValue"
                      ref="input"
                      v-model="innerValue"
                      :id="localInputId"
                      :autofocus="focus"
                      :autocomplete="autocomplete"
                      :disabled="disabledCheck"
                      :placeholder="placeholder"
                      :state="getValidationState(validationContext)"
                      :maxlength="9"
                      :max="2147483647"
                  ></b-form-input>


                  <div v-if="(colorReduced || colorSketch)" :style="{'background-color':innerValue}"
                       class="show-palette-color"></div>

                  <div v-if="colorReduced && showColors" style="width: 300px;" @mouseover="onPaletteOver"
                       @mouseleave="onPaletteLeave">
                    <twitter-picker ref="palette" v-if="showColors" @input="updateColor" :value="innerValue"/>
                  </div>

                  <div v-else-if="colorSketch && showColors" style="width: 300px;" @mouseover="onPaletteOver"
                       @mouseleave="onPaletteLeave">
                    <sketch-picker ref="palette" v-if="showColors" @input="updateColor" :value="innerValue"/>
                  </div>

                </div>

              </template>

              <template v-if="type === 'textarea'">

                <b-form-textarea
                    v-model="innerValue"
                    :rows="rows"
                    :autofocus="focus"
                    :id="localInputId"
                    :class="{'upperCase':localUpper,'lowerCase':localLower,[classInput] : classInput !== ''}"
                    :disabled="disabledCheck"
                    :placeholder="placeholder"

                    @focusin="onFocusInTextarea"
                    @focusout="onFocusOutTextarea"
                    ref="input"
                    :state="getValidationState(validationContext)"/>

                <b-row v-if="enableOptimizeAi">

                  <b-col cols="9" v-if="enableOptimizeAi" class="mt-1 mb-2">

                    <t-button small @click="optimizeIA()">
                      <b-icon-stars class="mr-2"/>
                      Otimizar com IA
                    </t-button>

                  </b-col>

                  <small class="small-right mt-1 col-3" v-if="innerValue !== null"> {{
                      innerValue.length + "/" + maxLength
                    }}</small>

                </b-row>

                <b-row v-else>

                  <small class="small-left mt-1 col-9">
                      <span v-if="localSmall !== null && localSmall.length > 0">
                        {{localSmall}}
                      </span>
                  </small>
                  <small class="small-right mt-1 col-3" v-if="innerValue !== null"> {{innerValue.length + "/" + maxLength}}</small>

                </b-row>

              </template>

              <template v-if="type === 'select'">

                <multiselect
                    v-if="multiSelectOptionGrouped"
                    v-model="multiSelectObject" :options="localOptions"
                    :disabled="disabledCheck"
                    :class="{'is-invalid':checkInvalid(validationContext)}"
                    :loading="busy"
                    ref="multiselect"
                    :state="getValidationState(validationContext)"
                    @search-change="onMultiSelectSearch"
                    @select="onMultiSelectSelected" @remove="onMultiSelectRemove"
                    :placeholder="placeholder"
                    group-values="options" selectLabel="" :showLabels="false"
                    group-label="groupLabel" track-by="value" label="text">

                  <template #noResult>
                    <slot name="no-options" :search="multiSelectSearch">{{ t('no-options') }}</slot>
                  </template>

                  <!--BUG QUANDO UTILIZADO VALUE DO TIPO TEXT, ONDE NÃO É EXIBIDO O BOTÃO CLEAR, CORREÇÃO MANUAL ATRAVÉS DE INSERÇÃO OPÇÃO NOVA '' TODOS-->
                  <template #clear v-if="!disabledCheck">
                    <div class="multiselect__clear" v-if="checkExistsValueSelect()"
                         @mousedown.prevent.stop="multiSelectClear()"></div>
                  </template>

                </multiselect>


                <multiselect
                    v-else
                    v-model="multiSelectObject" :options="localOptions"
                    :disabled="disabledCheck"
                    :class="{'is-invalid':checkInvalid(validationContext)}"
                    :loading="busy"
                    ref="multiselect"
                    :state="getValidationState(validationContext)"
                    @search-change="onMultiSelectSearch"
                    @select="onMultiSelectSelected" @remove="onMultiSelectRemove"
                    selectLabel="" :showLabels="false"
                    :placeholder="placeholder" track-by="value" label="text">

                  <template v-if="selectColors" #singleLabel="{option}">
                    <div class="d-flex">
                      <div class="mr-2" style="width: 20px; height: 20px; border-radius: 5px;"
                           :style="{'background-color':option.appendage}"></div>
                      <div class="option__small">{{ option.text }}</div>
                    </div>
                  </template>


                  <template v-if="selectColors" #option="{option}">

                    <div class="d-flex">
                      <div class="mr-2" style="width: 25px; height: 25px; border-radius: 7px;"
                           :style="{'background-color':option.appendage}"></div>
                      <div class="option__small" style="line-height: 30px">{{ option.text }}</div>
                    </div>
                  </template>

                  <template v-if="selectImages" #singleLabel="{option}">
                    <div class="d-flex">
                      <div class="mr-2" style="width: 20px; height: 20px; border-radius: 5px;"
                           :style="{'background-image':option.appendage}"></div>
                      <div class="option__small">{{ option.text }}</div>
                    </div>
                  </template>


                  <template v-if="selectImages" #option="{option}">

                    <div class="d-flex">
                      <div class="mr-2" style="width: 25px; height: 25px; border-radius: 7px;"
                           :style="{'background-image':option.appendage}"></div>
                      <div class="option__small" style="line-height: 30px">{{ option.text }}</div>
                    </div>
                  </template>

                  <template #noResult>
                    <slot name="no-options" :search="multiSelectSearch">{{ t('no-options') }}</slot>
                  </template>

                  <template #noOptions>

                    <slot name="no-options" :search="multiSelectSearch">{{ t('no-options') }}</slot>
                  </template>

                  <template #clear v-if="!disabledCheck">
                    <div class="multiselect__clear" v-if="value > 0 || value !== ''"
                         @mousedown.prevent.stop="multiSelectClear()"></div>
                  </template>

                </multiselect>

              </template>

              <template v-if="type === 'selectCommon'">

                <b-form-select
                    v-model="innerValue"
                    :autofocus="focus"
                    :id="localInputId"
                    :disabled="disabledCheck"
                    :options="localOptions"
                    :placeholder="placeholder"
                    :state="getValidationState(validationContext)"
                    class="form-control"

                ></b-form-select>

              </template>

              <template v-if="type === 'radio'">


                <b-form-radio-group
                    :id="localInputId"
                    v-model="innerValue"
                    :disabled="disabledCheck"
                    :options="localOptions"
                    class="form-control height-auto"
                    @change="onClickRadio"
                    :class="{'is-invalid':checkInvalid(validationContext), 'height-auto':stacked}"
                    value-field="value"
                    text-field="text"
                    :stacked="stacked"
                    :size="radioButton ? 'sm' : ''"
                    :button-variant="radioButton ? 'outline-focus' : ''"
                    :buttons="radioButton"
                    :state="getValidationState(validationContext)"

                ></b-form-radio-group>


              </template>

              <template v-if="type === 'checked'">

                <b-form-checkbox
                    :id="localInputId"
                    v-model="innerValue"
                    :disabled="disabledCheck"
                    :class="{'is-invalid':checkInvalid(validationContext)}"
                    :state="getValidationState(validationContext)"
                >{{ label }}
                </b-form-checkbox>

              </template>

              <template v-if="type === 'checkbox'">


                <b-form-checkbox-group
                    :id="localInputId"
                    v-model="innerValue"
                    :disabled="disabledCheck"
                    :options="localOptions"
                    class="form-control"
                    :class="{'is-invalid':checkInvalid(validationContext)}"
                    value-field="value"
                    text-field="text"
                    :state="getValidationState(validationContext)"

                ></b-form-checkbox-group>

              </template>

              <template #append v-if="hasSlotGroupInputAppend">
                <slot name="input-group-append"></slot>
              </template>


            </b-input-group>

          </t-wrapped>

          <slot></slot>

          <small v-if="localSmall && localSmall.length > 0 && type!=='textarea'"><em v-html="localSmall"></em></small>

          <b-form-invalid-feedback v-if="type==='select' && formStatus !== ''" style="display: inherit"
                                   :class="{'display-none':getValidationState(validationContext)}">
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>

          <b-form-invalid-feedback v-else :state="getValidationState(validationContext)">
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>

        </b-form-group>

      </ValidationProvider>

    </b-row>

  </t-wrapped>

</template>
<script>
import ui from "@/assets/scripts/ui";
import http from "@/services/config/http-common"

export default {
  name: 't-input',
  props: {
    busy: Boolean,
    multiple: Boolean,
    colorReduced: Boolean,
    colorSketch: Boolean,
    classInput: {
      type: String,
      default: ""
    },
    classIconGroup: {
      type: String,
      default: ""
    },
    acceptZero: Boolean,
    iid: {
      type: String,
      default: ""
    },
    formStatus: {
      type: String,
      default: ""
    },
    formCommand: {
      type: String,
      default: 'insert'
    },
    addError: {
      type: String,
      default: ""
    },
    submitted: Boolean, //Aceita submit no enter do campo
    focus: Boolean, //Setar o foco no campo
    radioButton: Boolean,//Converte Radio em um Button
    stacked: Boolean,
    help: {
      type: String,
      default: ""
    },
    small: { //Texto auxiliar por baixo do input
      type: String,
      default: "",
    },
    notRow: {
      type: Boolean,
      default: false
    },

    codeLabel: Boolean,
    firstDefault: Boolean,
    highlight: Boolean, //Utilizado quando é fixo, sendo para deixar mais evidente o campo que o normal
    bold: Boolean, //Utilizado quando é fixo, sendo para deixar mais evidente o campo que o normal
    fixed: Boolean, //Fixado em todos os comandos
    fixedInsert: Boolean, //Fixado somente na inclusão
    fixedExceptInsert: Boolean, //Fixado em todos os comandos, exceto insert que deverá ser oculto
    hidden: Boolean,
    text: Boolean,
    textarea: Boolean,
    enableOptimizeAi: Boolean,
    select: Boolean,
    selectColors: Boolean,
    selectImages: Boolean, /*Não utilizado e implemetado 100%*/
    selectCommon: Boolean,
    radio: Boolean,
    range: Boolean,
    checked: Boolean, //Checked unitário
    checkbox: Boolean, //Checked Array
    upload: Boolean, //Aceito os formatos, pdf, xls, xlsx, jpg, jpeg, png, doc, docx
    uploadImage: Boolean, //Aceito somente jpg, jpeg, png
    uploadMaxSize: { //Tamanho máximo do upload aceito, por padrão será 5, porém só será usado quando estiver marcado upload ou upload-image
      type: String,
      default: "5"
    },
    uploadMaxFiles: { //Qtd. máxima de arquivos aceitos, utilizado somente quando marcado como upload ou upload-image
      type: String,
      default: "1"
    },
    password: Boolean,
    passwordSecurity: Boolean,
    date: Boolean,
    datetime: Boolean,
    time: Boolean,
    dateRemoveCalendar: Boolean,
    email: Boolean,
    emailMultiple: Boolean,
    url: Boolean,
    tel: Boolean,
    number: Boolean,
    percent: Boolean,
    money: Boolean,
    cep: Boolean,
    cnpjOrCpf: Boolean, //Mascara de CNPJ ou CPF dinamica
    cnpj: Boolean,
    cpf: Boolean,
    api: Boolean, //Aplicação de api para campos como CEP, CNPJ e Placa
    dateNow: Boolean,
    minLength: {
      type: String,
      default: "0"
    },
    maxLength: {
      type: String,
      default: "255"
    },
    lpad: {/*VALIDO SOMENTE PARA EXIBIÇÕES DO FIXED*/
      type: [Number, String],
      default: ""
    },
    decimals: {
      type: [String, Number],
      default: ""
    },
    vid: {
      type: String,
      default: undefined
    },
    name: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: [Object, String],
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    notAutocomplete: Boolean,
    placeholder: {
      type: String,
      default: ""
    },
    rows: {
      type: [Number, String],
      default: 2,
    },
    value: {
      type: null,
      default: ""
    },
    enableOptionAllText: {
      type: String,
      default: '',
    },
    options: [],
    cols: {
      type: [String, Number],
      default: "12"
    },
    row: {
      type: Boolean,
      default: false
    },
    upper: Boolean,
    lower: Boolean,
    onlyNumbers: Boolean,
    onlyLetters: Boolean,
    onlyLettersAndNumbers: Boolean,
  },
  data() {
    return {
      validityEnabled: true,
      oldValue: "",
      applyConvertingMoney: false,
      localInputId: "",
      localUpper: "",
      localLower: "",
      localAddError: "",
      localSmall: "",
      localRules: "",
      localLabel: "",
      localDecimals: 0,
      localOptions: [],
      inputIsFocus: false,
      maskApply: false,
      hasError: false,
      hasIconByMask: false,
      localBusy: false,
      innerValue: "",
      innerNumeric: null,
      innerDate: "",
      autocomplete: "",
      type: String,
      maskSize: 0,
      isInputNumeric: false,
      currentDate: "",
      multiSelectSearch: "",
      multiSelectObject: [],
      multiSelectOptionGrouped: false,
      hasSlotInputIcon: false,
      hasSlotGroupInputPrepend: false,
      hasSlotGroupInputAppend: false,
      showColors: false,
      paletteInOver: false,
      initialValueSet: false,

      moneyConfig: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        precision: 2,
        masked: false // Define se o valor é armazenado como string ou número
      }

    }
  },
  mounted() {

    this.hasSlotInputIcon = !!this.$slots["input-icon"]
    this.hasSlotGroupInputPrepend = !!this.$slots["input-group-prepend"]
    this.hasSlotGroupInputAppend = !!this.$slots["input-group-append"]

    this.localDecimals = parseInt(this.decimals)

    if (this.iid !== '') {
      this.localInputId = this.iid
    } else {

      let label = this.label

      if (label === null) {
        label = ''
      }

      this.localInputId = label.replace(/[^a-zA-Z\d]/g, '') + "_" + ui.generateRandomNumber(1000, 9999);
    }


    if (this.date || this.datetime) {

      this.currentDate = ui.convertDateBR(new Date(), this.datetime)

      //Seta a data padrão do dia atual somente nestas condições a seguir
      //todo está apresentando falha quando utilizando em conjunto com disable ou fixed-except-insert, por tanto evitar o uso do date-now quando houver atributo
      if (this.dateNow && this.formCommand === 'insert' && this.innerValue === '' && !this.fixedExceptInsert) {
        this.setCurrentDate(false)
      }


    }

    if ((this.percent || this.money) && this.decimals === '') {
      //2 casas decimais por padrão quando não especificado
      this.localDecimals = 2
    }

    /*-------------------*/
    this.applyRules()

    this.innerValue = this.value

    /*console.log('rules:'+this.localRules)*/


  },
  computed: {


    selectText() {

      if (this.localOptions && this.localOptions.length && this.localOptions.length > 0 && this.innerValue !== "" && this.innerValue !== null) {

        this.multiSelectSetValue()
        return this.multiSelectObject.text

      } else {
        return ""
      }
    },

    disabledCheck() {
      return this.disabled || this.formStatus === "sending" || this.localBusy
    },


  },
  watch: {


    select() {
      this.applyRules()
    },

    disabled(v) {

      if (v && this.$refs.multiselect) {
        this.$refs.multiselect.deactivate()
      }

    },

    options() {
      this.checkOptions()
    },

    formCommand() {

      this.applyFixed()
      this.checkIsRequired()
      this.checkLabel()

    },

    /*
    * Necessário aplicar nos props que possuem validação especial, pois o input pode estar condicionado e não ter sido montado com a mascara corretamente*/
    cnpj() {
      this.applyRules()
    },
    cpf() {
      this.applyRules()
    },
    cep() {
      this.applyRules()
    },
    /*------------------------*/

    addError(value) {

      this.localAddError = value
      //Necessário, pois não estava atualizando corretamente as mensagens de erro
      setTimeout(() => this.applyRules(), 200)

    },

    small(v) {
      this.localSmall = v
    },

    label() {
      this.checkLabel()
    },

    required() {
      this.checkIsRequired()
      this.checkLabel()
    },

    fixed() {
      this.applyRules()
    },

    fixedInsert() {
      this.applyRules()
    },

    //Deverá estar sempre no padrão da conta no caso: DD/MM/YYYY, já o innerValue, deverá estar sempre no padrão: YYYY-MM-DD
    innerDate(value, old) {

      let d = value

      //Data válida, podendo ser YYYY-MM-DD ou DD/MM/YYYY
      if (d !== null && d !== '' && d.length === 10) {

        if (value.indexOf('/') > 0) {
          //Está no padrão esperado e padronizado: DD/MM/YYYY

          const dataArray = value.split('/')

          let date = new Date(dataArray[2], dataArray[1] - 1, dataArray[0]);

          //const date = new Date(value)
          let dateIso
          if (this.datetime) {
            dateIso = date.toISOString()
          } else {
            dateIso = date.toISOString().split('T')[0]
          }

          this.innerValue = dateIso

        } else {

          //Converte para o padrão brasileiro e centralizar sempre as origens em padrão brasileiro
          //Fazendo isso será chamado novamente, porém já formatado no padrão esperado para innerDate que sempre contem a data para o cliente e não aquela armazenada
          this.innerDate = ui.convertDateBR(d, false)


        }

      } else {

        if (value !== '' && value !== null && value !== undefined) {

          if (value.length > old.length) {
            //Aplicar somente quando estiver crescendo

            if (value.length === 2 || value.length === 5) {
              value += '/'
            }

          }
        }
        this.innerDate = value
        this.innerValue = value
      }

    },

    innerNumeric(value) {

      //Retira o zero somente se não for obrigatório, pois será aceito o zero no
      if (value) {

        let round_number = value
        let value_converted = value

        if (this.localDecimals > 0) {

          round_number = parseFloat(value.toFixed(this.localDecimals));

          if (this.percent || this.money) {
            //Campos que utilizam o v-money e precisam ter os decimais padronizados
            value_converted = ui.convertNumber(round_number, this.localDecimals, "pt-br", true)
          } else {
            value_converted = ui.convertNumber(round_number, this.localDecimals, "pt-br")
          }

        }

        /*console.log("Valor localDecimals recebido: " + this.localDecimals)
        console.log("Valor numerico recebido: " + this.innerNumeric)
        console.log("Valor Interno: " + this.innerValue)
        console.log("Valor numerico arredondado: " + round_number)
        console.log("Valor convertido convertido: " + value_converted)*/

        this.innerNumeric = round_number
        this.innerValue = value_converted

        //DEVE TRAVAR O RETORNO AQUI MESMO PARA EVITAR INCONSTÊNCIA ENTRE O VALOR EXTERNO E INTERNO
        this.$emit("input", round_number)
        this.$emit("change", round_number)


      } else {

        //Caso o valor antigo esteja em branco, continuará em branco
        if (this.acceptZero) {
          this.innerNumeric = 0
          this.innerValue = "0"
        } else {
          this.innerValue = ""
        }

        this.$emit("input", 0)
        this.$emit("change", 0)

      }

    },

    decimals() {
      this.applyRules()
    },

    innerValue(value) {

      if (this.isInputNumeric) {


        if (typeof value !== 'number' && value) {

          //Deverá converter e emitir convertido
          let v = String(value)

          if (v === 'R$ 0,00' || v === '') {
            v = 0
          } else {
            const convert = v.replace('R$', '').replace(/ /g, '').replace(/\./g, '').replace(',', '.')
            v = parseFloat(convert)
          }

          if (v !== this.innerNumeric) {

            this.innerNumeric = v

            this.$emit("input", this.innerNumeric)
            this.$emit("change", this.innerNumeric)
          }


        } else {

          this.innerNumeric = value

          if (this.money || this.percent) {
            this.$emit("input", this.innerNumeric)
            this.$emit("change", this.innerNumeric)

            /*console.log('okkk',this.innerNumeric)*/

          }
        }


      } else if (this.date) {


        if (value === null) {
          this.innerValue = ""
          value = ""
        }

        if ((value !== '' && (value.length === 10)) || value === '') {

          //Somente emite para informar que há alteração
          this.$emit("input", value)

          if (this.value !== value) {
            this.$emit("change", value)
          }

        }

        //let d = value
        /*if (d !== '' && d.length === 10 && d.indexOf('/') > 0) {

          const dia = d.split("/")[0];
          const mes = d.split("/")[1];
          const ano = d.split("/")[2];

          const convert = ano + '-' + ("0" + mes).slice(-2) + '-' + ("0" + dia).slice(-2)

          //Retorna para o objeto a data convertida
          this.innerDate = convert

          if (!this.dateRemoveCalendar) {
            if (this.$refs.datePicker && this.$refs.datePicker.opened)
              this.$refs.datePicker.close()
          }

          this.$emit("input", convert)
          this.$emit("change", convert)

        } else if (d === '') {

          this.$emit("input", '')
        } else {
          //Valor já no padrão correto, por tanto armazena com valor correto apenas
          if (d !== '' && d.length === 10 && d.indexOf('-') > 0)
            this.innerDate = d
        }*/

      } else if (this.datetime) {

        let d = value


        if (d !== '' && d !== null && d.indexOf('/') > 0) {
          //Está no padrão brasileiro precisa converter

          //todo pendente


        } else {
          //Valor já no padrão correto, por tanto armazena com valor correto apenas
          if (d !== '' && d !== null && d.length === 29 && d.indexOf('-') > 0)
            this.innerDate = d
        }

      } else {
        //Tipos genéricos

        this.$emit("input", value);

        if (this.innerValue !== this.value) {
          this.$emit("change", value)
        }


        this.multiSelectSetValue()

      }

    },
    value(val) {


      if (val !== this.innerValue && !this.isInputNumeric && !this.date) {
        this.innerValue = val;
      }

      if (this.isInputNumeric) {

        if (val !== this.innerNumeric && val !== null) {
          this.innerNumeric = val
        }


      }

      if (this.date) {

        if (val !== this.innerDate) {

          this.innerDate = val
        }

      }

    }

  },
  created() {


    if (this.value) {

      //Seta o valor inicial
      this.innerValue = this.value

    }

  },
  methods: {

    onClickRadio() {
      this.$emit('click', this.innerValue)
    },

    onPaletteOver() {
      this.paletteInOver = true
    },

    onPaletteLeave() {

      this.paletteInOver = false

      if (!this.inputIsFocus) {
        this.showColors = false
      }

    },
    async optimizeIA() {

      if (this.value !== '') {

        this.localBusy = true

        await http.post("resources/IA", {message: this.value})
            .then(response => {
              this.localBusy = false
              this.innerValue = response.data.message
            }).catch(
                error => {
                  console.log(error)
                  this.localBusy = false
                }
            )
      }

    },

    updateColor({hex}) {
      this.innerValue = hex
      this.showColors = false
      this.paletteInOver = false
    },

    onMultiSelectRemove(selectedOption) {
      this.value = selectedOption.value
      this.validityEnabled = false

      setTimeout(() => {
        this.multiSelectObject = selectedOption
      }, 50)

      setTimeout(() => {
        this.validityEnabled = true
      }, 150)


    },
    onMultiSelectSearch(searchQuery) {
      this.$emit("search", searchQuery)
      this.multiSelectSearch = searchQuery

    },
    onMultiSelectSelected(selectedOption) {
      this.innerValue = selectedOption.value
    },
    checkExistsValueSelect() {

      const valueString = "" + this.value

      return valueString !== '' && valueString !== '0'

    },
    multiSelectClear() {

      if (typeof this.value === 'string') {
        this.innerValue = ""
      } else {
        this.innerValue = 0
      }

      this.multiSelectSearch = ''
      this.multiSelectObject = []
      this.$refs.multiselect.deactivate()


    },
    multiSelectSetValue() {


      if (this.innerValue === 0)
        this.multiSelectObject = []

      if ((this.select || this.selectColors || this.selectImages || this.selectCommon || this.radio) && this.localOptions) {

        let qtdElements = 0
        let lastItem = {}

        for (const option of this.localOptions) {

          if (option.options && option.options.length > 0) {
            //Possui formato com grupo

            this.multiSelectOptionGrouped = true

            //Verifica internamente somente se houver valor selecionado no v-model
            for (const inside of option.options) {

              qtdElements++
              lastItem = inside

              if (inside.value === this.innerValue && this.innerValue > 0) {
                this.multiSelectObject = inside
              }
            }


          } else {
            //Não possui formato com grupo

            qtdElements++
            lastItem = option

            this.multiSelectOptionGrouped = false

            if (this.innerValue && option.value.toString() === this.innerValue.toString()) {
              this.multiSelectObject = option
            }

          }

        }

        if (qtdElements === 1
            && (this.innerValue === 0 || this.innerValue === "")
            && this.formCommand === 'insert'
            && this.firstDefault) {


          this.innerValue = lastItem.value
          this.multiSelectObject = lastItem

        }

      }

    },


    applyFixed() {

      if ((this.formCommand === "view" || this.formCommand === 'delete') && !this.hidden) {
        this.type = "fixed"
      } else if (this.fixedExceptInsert && this.formCommand !== "insert") {
        this.type = "fixed"
      } else if (this.fixedInsert && this.formCommand === "insert") {
        this.type = "fixed"
      }


    },

    applyManualError() {


    },

    applyRules() {

      /*
    * Aplicação de tipo rápida com booleanos*/


      if (this.hidden) {
        this.type = "hidden"
      } else if (this.fixed) {
        this.type = "fixed"
      } else if (this.upload || this.uploadImage) {
        this.type = "file"
      } else if (this.textarea) {
        this.type = "textarea"
      } else if (this.select || this.selectColors || this.selectImages) {
        this.type = "select"
      } else if (this.selectCommon) {
        this.type = "selectCommon"
      } else if (this.radio) {
        this.type = "radio"
      } else if (this.checked) {
        this.type = "checked"
      } else if (this.range) {
        this.type = "range"
      } else if (this.checkbox) {
        this.type = "checkbox"
      } else {

        this.type = "text"

        //Informa de forma rápida que houve aplicação de máscara para agilizar renderização
        if (
            this.date
            || this.url
            || this.tel
            || this.time
            || this.number
            || this.percent
            || this.money
            || this.cep
            || this.cnpjOrCpf
            || this.cnpj
            || this.cpf

        ) this.maskApply = true


        //Mascaras que aplicam ícone automaticamente
        if (
            (this.date && !this.dateRemoveCalendar)
        ) {
          this.hasIconByMask = true
        }

        if (this.money || this.number || this.percent) {
          this.isInputNumeric = true
        }

      }

      this.localSmall = this.small
      this.localUpper = this.upper
      this.localLower = this.lower
      this.localRules = this.rules


      if (this.type === "text" || this.type === "textarea") {
        //Regras de máscaras e outros para estes tipos apenas
        this.localRules += "|max:" + this.maxLength

        if (this.minLength !== "" && this.minLength !== "0") {
          this.localRules += "|min:" + this.minLength
        }

        if (this.onlyNumbers) {
          this.localRules += "|only_numbers"
        } else if (this.onlyLetters) {
          this.localRules += "|only_letters"
        } else if (this.onlyLettersAndNumbers) {
          this.localRules += "|only_letters-and-numbers"
        }

      }

      if (this.date) {
        /*this.localRules += "|date"*/
      } else if (this.time) {
        this.localRules += "|time"
      } else if ((this.money || this.percent) && this.required && !this.acceptZero) {
        this.localRules += "|numeric_not_zero"
      } else if (this.cnpj) {
        this.localRules += "|cnpj"
        this.maskSize = 18 //Utilizado para validações quando terminar o preenchimento e enquanto esta com focus
      } else if (this.cpf) {
        this.localRules += "|cpf"
        this.maskSize = 14 //Utilizado para validações quando terminar o preenchimento e enquanto esta com focus
      } else if (this.cep) {
        this.localRules += "|cep"
        this.maskSize = 9
      } else if (this.email) {
        this.localRules += "|email"
        this.localLower = true
      } else if (this.emailMultiple) {
        this.localRules += "|email_multiple"
        this.localLower = true
        this.localSmall = "Insira mais que um e-mail separando por ;"
      } else if (this.url) {
        this.localRules += "|url"
        this.localLower = true
      } else if (this.passwordSecurity) {
        this.localRules += "|password_security"
      } else if (this.colorReduced || this.colorSketch) {
        this.localRules += "|color"
        this.maskSize = 7 //Utilizado para validações quando terminar o preenchimento e enquanto esta com focus
      }


      //Regras manuais adicionadas para utilização de validação backend com campo específico
      if (this.localAddError.length > 0) {
        this.localRules += "|manual_rule:" + this.localAddError
      }


      if (this.notAutocomplete) {
        //Remover autocomplete
        this.autocomplete = "off"
      } else {
        this.autocomplete = this.password || this.passwordSecurity ? "new-password" : ''
      }

      this.applyFixed()
      this.checkIsRequired()
      this.checkLabel()
      this.checkOptions()

      this.innerValue = this.value


    },

    onFocusInInput() {
      //Armazena o valor para saber se houve mudanças
      this.oldValue = this.innerValue
      this.inputIsFocus = true

      if (this.colorReduced || this.colorSketch) {
        this.showColors = true
      }

      if (this.isInputNumeric && this.innerNumeric === 0) {
        //Deixa selecionado para facilitar a edição, pois se não dará pau
        this.innerValue = ""
        document.getElementById(this.localInputId).value = ""
      }

      this.$emit("focusin")

    },

    onFocusInTextarea() {
      //Armazena o valor para saber se houve mudanças
      this.oldValue = this.innerValue

      this.inputIsFocus = true
      this.$emit("focusin")

    },

    onFocusOutTextarea() {

      if (this.innerValue !== null && this.innerValue !== '') {
        this.innerValue = this.innerValue.trim()
      }

      this.inputIsFocus = false
      this.$emit("focusout")

    },

    onFocusOutInput() {

      if (this.date || this.datetime) {

        //Tempo necessário para obter o valor de innerDate atualizado pelo picker
        setTimeout(() => {


          if (this.innerDate.length !== 10 || this.innerDate.match(/^\d{2}[./-]\d{2}[./-]\d{4}$/) === null) {
            //Correção, pois a data esta incompleta
            this.innerValue = ''
            this.innerDate = ''
          }

        }, 200)


      } else {

        if (this.innerValue !== null && this.innerValue !== '' && isNaN(this.innerValue)) {

          this.innerValue = this.innerValue.trim()

          if (this.password || this.passwordSecurity || this.email || this.emailMultiple) {
            //Retira tabs neste caso
            this.innerValue = this.innerValue.replaceAll('\t', '')
          } else if (this.onlyLetters) {
            this.innerValue = this.innerValue.replace(/[^a-zA-Z]/g, '')
          } else if (this.onlyNumbers) {
            this.innerValue = this.innerValue.replace(/\D/g, '')
          } else if (this.onlyLetters) {
            this.innerValue = this.innerValue.replace(/[^a-zA-Z\D]/g, '')
          } else if (this.codeLabel) {
            //Campos do tipo code Label não poderão ter espaço por regra geral
            this.innerValue = this.innerValue.replaceAll(/ /g, '')
            this.innerValue = this.innerValue.replaceAll('\t', '')
          } else {
            //Substituir por espaço
            this.innerValue = this.innerValue.replaceAll('\t', ' ')

            //Correção de espaços duplos entres
            this.innerValue = this.innerValue.replaceAll(/  +/g, ' ')
          }

        }

      }


      let v = this.innerValue

      if ((this.colorReduced || this.colorSketch) && !this.paletteInOver) {
        this.showColors = false
      }

      if (this.localAddError.length > 0) {
        //Retira erro manual para novo submit, pois este é utilizado somente uma vez para exibição ao usuário
        this.localAddError = ''
        this.applyRules()
      }

      if (this.localUpper && v != null) {
        this.innerValue = v.toString().toUpperCase()
      } else if (this.localLower && v != null) {
        this.innerValue = v.toString().toLowerCase()
      }


      //Regras específicas
      if (this.emailMultiple) {


        if (v && v.length > 0) {

          v = v.replace(/ /g, '').replace(/,/g, ';').replace(/;;/g, ';')

          if (v.substring(v.length - 1) === ";") {
            v = v.substring(0, v.length - 1)
          }

          this.innerValue = v

        }

      }


      if (this.api && this.cep && this.innerValue.length === this.maskSize && this.oldValue !== this.innerValue) {

        const cep = this.innerValue.replace(/-/g, '')
        this.localBusy = true

        this.$http.get('https://viacep.com.br/ws/' + cep + '/json/')
            .then(response => {

              this.localBusy = false
              const a = response.data

              const address = {
                id: a.ibge,
                street: a.logradouro,
                province: a.uf,
                neighborhood: a.bairro,
                city: a.localidade,
              }

              this.$emit("get", address)


            }).catch(
            error => {
              console.log(error)
              this.localBusy = false
            }
        )

      } else if (this.api && this.cnpj && this.innerValue.length === this.maskSize && this.oldValue !== this.innerValue && !this.hasError) {

        //let cnpjValue = this.innerValue.replaceAll('.', '').replaceAll('/', '').replaceAll('-', '')

        //this.localBusy = true

        /*http.get('resource/CNPJ/' + cnpjValue)
            .then(response => {

              this.localBusy = false
              this.$emit("get", response.data)

            }).catch(
            error => {
              console.log(error)
              this.localBusy = false
            }
        )*/

      }

      this.inputIsFocus = false
      this.$emit("focusout")

    },

    checkNumericValue() {

      this.innerValue = ui.convertNumber(this.innerNumeric, this.localDecimals, "pt-br")

      //Tive que apelar, pois não trocava o valor interno de nenhuma forma
      let v = this.innerValue

      if (v === 0 && !this.acceptZero) {
        //Caso o valor anterior seja nullo e o novo seja 0 irá deixar nullo novamente para deixar o campo input vazio com estado inicial.
        this.innerValue = null
        v = null
      }

      document.getElementById(this.localInputId).value = v

    },

    applyDateMask() {
      /*  if(this.innerDate.length !== 10){

          if(this.innerDate.length === 2){
            this.innerDate += "/"
          //}else if(this.innerDate.length === 4){
          //  this.innerDate += "/"
          }
        }*/

    },

    dateRemoveByRegex() {

      if (this.innerDate !== null && this.innerDate !== '') {
        this.innerDate = this.innerDate.replace(/[^0-9/]/g, '').substring(0, 10)
      }


    },

    closeDatePicker() {

      if (this.$refs.datePicker && this.$refs.datePicker.closePopup)
        this.$refs.datePicker.closePopup()


    },

    setDateAndClose() {
      this.setCurrentDate(true)
      this.closeDatePicker()
    },

    setCurrentDate(forceInsert) {

      if (this.innerValue === '') {

        setTimeout(() => {
          this.checkDate(forceInsert)
        }, 1000)

      }

    },

    checkDate(forceInsert) {

      if ((this.formCommand === 'insert' && this.innerValue === '') || forceInsert)
        this.innerValue = ui.currentDate()


    },


    checkLabel() {

      this.localLabel = this.label

      if (typeof this.localRules === "string") {

        if (this.localRules.indexOf('required') > -1) {
          this.localLabel += ' *'
        }

      }

    },

    checkOptions() {

      this.checkEnableAllOptions()

      if (this.firstDefault && this.localOptions.length > 0 && this.formCommand === 'insert' && (this.innerValue === '' || this.innerValue === 0)) {

        if (this.type === 'selectCommon') {
          this.innerValue = this.multiSelectObject.value
        } else {
          this.innerValue = this.localOptions[0].value
        }

      } else if (this.type === 'select') {
        this.multiSelectSetValue();
      }
    },

    checkEnableAllOptions() {

      let newOptions = []

      if (this.enableOptionAllText !== '') {
        newOptions.push({
          value: '',
          text: this.enableOptionAllText,
        })
      }

      if (this.options) {

        for (const option of this.options) {
          newOptions.push(option)
        }

      }

      this.localOptions = newOptions

    },


    checkIsRequired() {

      if (this.required && this.type !== 'fixed') {

        if (this.localRules.indexOf('required') === -1) {
          this.localRules += "|required"
        }

      } else {
        this.localRules = this.localRules.replace('|required', '').replace('required', '')
      }


    },

    handleDatePickerChange(value) {
      console.log(value)
    },

    getValidationState({errors, validated, valid = null, failedRules}) {

      if (errors.length > 0 && this.validityEnabled) {

        const arrayImmediate = ["max", "only_numbers", "only_letters", "only_letters-and-numbers", "password_security", "manual_rule"]
        const arrayMasks = ["min", "cpf", "cnpj", "cep", "color"]

        //Verifica se há erros que devem ser apresentados mesmo antes do envio do formulário como limite de caracteres, minimo de valor ou maximo de valores. Podendo ser no onblur ou de forma imediata
        const errorsBeforeSubject = Object.keys(failedRules).filter(rule => rule !== "required");

        //Por padrão todos serão validados desta listagem após o blur, porém poderemos especificar se há validações imediatadas
        const errorValidateImmediate = errorsBeforeSubject.filter(rule => arrayImmediate.includes(rule))

        //Validações após saída do focus
        const errorValidateBeforeFocus = errorsBeforeSubject.filter(rule => arrayMasks.includes(rule))

        //Validações enquanto houver focus e se a mascara foi digitada até o final
        const errorValidateImmediateAndMaskApply = errorsBeforeSubject.filter(rule => arrayMasks.includes(rule))

        //Faz a validação antes do envio após sair do campo ou se deverá aplicar em tempo real
        if (errorsBeforeSubject.length > 0 && (

            //Validações imediatas
            (!this.inputIsFocus || (errorValidateImmediate && errorValidateImmediate.length > 0)) ||

            //Validações após saída do focus
            (!this.inputIsFocus && errorValidateBeforeFocus) ||

            //Validações imediatas, porém somente se tiver atingido a quantidade de caracteres da máscara
            (!this.inputIsFocus && (errorValidateImmediateAndMaskApply && errorValidateImmediateAndMaskApply.length > 0 && this.maskSize === this.innerValue.length))

        )) {

          this.hasError = false
          return false

        } else {

          this.hasError = !valid

          if (errors.length > 0 && this.formStatus === "subject") {
            return validated ? valid : null;
          } else {
            return null
          }

        }

      }


    },

    checkInvalid(validationContext) {

      let temp = this.getValidationState(validationContext)

      //Somente neste caso é inválido, pois já foi verificado e o campo não foi preenchido. (quando retorna null significa que não foi validado ainda)
      return temp === false

    }
  }
}
</script>
<style>
</style>
